function Collapser(){
	var me = this;

	me.collapser = function(){
		var target = $(this).data('target');
		if( target ){
			$(target).addClass('collapse').removeClass('in');
		}
	}

	me.uncollapser = function(){
		var target = $(this).data('target');
		if( target ){
			$(target).addClass('collapse').addClass('in');
		}
	}	

	me.observe = function(){
		$('[data-toggle=collapser]').click(me.collapser);
		$('[data-toggle=uncollapser]').click(me.uncollapser);
	}
	me.observe();
}

$( function(){
	new Collapser();
})